<template>
  <div class="solution-face-in">
    <div class="banner">
      <solution-banner :bannerInfo="bannerConstant.SolutionForgery"></solution-banner>
    </div>
    <div class="solution-bar" :class="{'is-fixed': secondNavFixed}">
      <div class="anchors-items">
        <div class="anchors-item" :class="{'active-anchors' : index == indexActive}"
          v-for="(item, index) in AnchorsItems" :key="index" @click="goAnchor('#anchor-'+index, index)">
          {{item}}
        </div>
      </div>
    </div>
    <div class="solution-bar-place" v-if="secondNavFixed"></div>
    <div id="anchor-0" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[0]}}
      </div>
      <div class="solution-content-intro">
        <div class="content">
          海外部分地区存在身份证件联网核查机制不全，无法对身份证件的真伪进行判断，带来了一定的安全隐患。优图证件鉴伪解决方案基于业内领先的优图领先视频鉴伪技术，不仅可以精准识别出互联网金融场景常见的复印、翻拍、遮挡等常见伪证技术，还可以对高仿假证进行有效拦截，助力客户线上业务安全可靠的开展。
        </div>
      </div>
    </div>
    <div id="anchor-1" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[1]}}
      </div>
      <div class="facein-img-intro">
        <div class="img-facein-function"></div>
      </div>
    </div>
    <div id="anchor-2" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[2]}}
      </div>
      <div class="advantage-container">
        <scheme-advantage :advantageInfo="advantageConstant.SolutionForgery"></scheme-advantage>
      </div>
    </div>
    <div id="anchor-3" class="items-details">
      <div class="solution-title">
        {{AnchorsItems[3]}}
      </div>
      <div class="application-container">
        <application-scene :sceneInfo="applicationConstant.SolutionForgery"></application-scene>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from '../common/SolutionBanner';
import SchemeAdvantage from '../common/SchemeAdvantage';
import ApplicationScene from '../common/ApplicationScene';
import bannerConstant from './data/BannerConstant';
import advantageConstant from './data/AdvantageConstant';
import applicationConstant from './data/ApplicationConstant';
import ScrollManager from '@/components/open/common/ScrollManager';
import HandleAnchor from './js/HandleAnchor';

export default {
  name: '',
  components: {
    SolutionBanner,
    SchemeAdvantage,
    ApplicationScene
  },
  data() {
    return {
      bannerConstant,
      advantageConstant,
      applicationConstant,
      AnchorsItems: ['方案介绍', '方案流程', '方案优势', '应用场景'],
      secondNavFixed: false,
      activeFacein: true,
      indexActive: 0
    };
  },
  methods: {
    handleMouseScroll(param) {
      HandleAnchor.mouseScroll(param, this);
    },
    goAnchor(selector, index) {
      HandleAnchor.mouseClick(selector, index, this);
    }
  },
  mounted() {
    ScrollManager.register(this.handleMouseScroll);
  },
  beforeDestroy() {
    ScrollManager.degister(this.handleMouseScroll);
  }
};
</script>

<style lang="less" scoped>
.solution-face-in {
  font-size: 14px;
  color: #333333;
  div {
    box-sizing: border-box;
  }
  .banner {
    height: 482px;
  }
  .solution-bar-place{
    height: 60px;
    width: 100%
  }
  .solution-bar {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    overflow: hidden;
    z-index: 2;
    background-color: #ffffff;
    border-bottom: 1px solid #eeeeee;
    .anchors-items {
      font-size: 0;
      text-align: center;
      .anchors-item {
        cursor: pointer;
        display: inline-block;
        margin: 0 45px;
        font-size: 17px;
        line-height: 50px;
        padding-top: 5px;
        &:hover {
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
        &.active-anchors{
          color: #00a6ff;
          border-bottom: 4px solid #00a6ff;
        }
      }
    }
    &.is-fixed{
      position: fixed;
      top: 63px;
      z-index: 1;
    }
  }
  .items-details{
    padding-bottom: 70px;
    &.client-case{
      background-color: rgb(245, 246, 247);
      padding-bottom: 100px;
    }
  }
  .solution-title{
    padding-top: 70px;
    margin-bottom: 40px;
    font-size: 30px;
    color: #333;
    text-align: center;
    line-height: 1.0;
  }
  .solution-content-intro{
    width: 1170px;
    margin: 0 auto;
    .content{
      font-size: 16px;
      color: #212121;
      line-height: 1.8;
      text-align: justify;
      margin-bottom: 26px;
    }
    .img-title {
      font-size: 22px;
      color: #212121;
      margin-top: 58px;
      margin-bottom: 26px;
      line-height: 1.0;
    }
  }
  .facein-process-nav {
    margin: 0 auto;
    width: 1200px;
    text-align: center;
    .nav-live-facein, .nav-live-compare {
      cursor: pointer;
      display: inline-block;
      margin: 0 45px;
      font-size: 17px;
      line-height: 50px;
      padding-top: 5px;
      &.active {
        color: #00a6ff;
        border-bottom: 4px solid #00a6ff;
      }
      &:hover {
        color: #00a6ff;
        border-bottom: 4px solid #00a6ff;
      }
    }
  }
  .facein-img-intro{
    .img-facein-function{
      width: 1170px;
      height: 678px;
      margin: 0 auto;
      background: url(./img/intro/id_antifacke_pic2.jpg);
    }
  }
  .application-container{
    width: 1170px;
    margin: 0 auto 40px;
    font-size: 0;
    .application-item-facein{
      display: inline-block;
      vertical-align: top;
      width: 360px;
      height: 322px;
      background-position: center 10px;
      background-repeat: no-repeat;
      color: #242526;
      margin-right: 45px;
      .application-item-title{
        padding-top: 180px;
        font-size: 24px;
        text-align: center;
      }
      .application-item-content{
        font-size: 16px;
        line-height: 1.8;
        margin-top: 22px;
        text-align: justify;
      }
      &.no-margin-right{
        margin-right: 0;
      }
    }
  }
  .client-case-facein{
    width: 1170px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0;
    .case-info, .case-img{
      display: inline-block;
      height: 340px;
      width: 585px;
      vertical-align: top;
    }
    .case-img{
      background-image: url('./img/case/facein_face_pic5.jpg');
    }
    .case-info {
      padding: 58px 36px;
      background: #ffffff;
      line-height: 40px;
      border: #f0f0f0 1px solid;
      border-right: none;
      .facein-title{
        line-height: 40px;
        font-size: 26px;
        padding-left: 138px;
        background-image: url(./img/case/facein_face_logowebank.png);
        background-repeat: no-repeat;
        background-position: 0 center;
      }
      .facein-content {
        margin-top: 28px;
        font-size: 16px;
        width: 510px;
        text-align: justify;
        line-height: 1.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/panels/SolutionForgery.vue